import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { HOME_LINK_ENABLED } from '@hdms/shared/ui-core';

@Component({
  selector: 'shrd-pf-ui-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderLogoComponent {
  readonly hasLink = inject(HOME_LINK_ENABLED);

  @Input() small = false;

  @HostBinding('class.header-logo-wrapper')
  get wrapperClass(): boolean {
    return !this.small;
  }
}
